import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../features/apiServices/apiClient";
import "./css/HomePage.css";
import safeJSON from "../components/safeJSON";
import { useTheme } from "../context/ThemeContext";
import { gerarPayloadPix } from "../utils/pixUtils";
import {
  clearSubscriptionStatus,
  setSubscriptionStatus,
} from "../features/subscription/subscriptionState";


const HomePage = () => {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  const token = localStorage.getItem("accessToken");
  const user = safeJSON("user");
  const tenant = safeJSON("tenant");
  //const activeRestaurant = safeJSON("activeRestaurant");
  const storedRestaurants = safeJSON("restaurants");
  const [activeRestaurant, setActiveRestaurant] = useState(safeJSON("activeRestaurant"));
  const [fluxoComandas, setFluxoComandas] = useState([0, 0, 0, 0, 0]);
  const [ocupacaoHorario, setOcupacaoHorario] = useState([0, 0, 0, 0, 0]);
  const [subscription, setSubscription] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [restaurants, setRestaurants] = useState([]);
  const [ocupadas, setOcupadas] = useState(null);
  const [kpis, setKpis] = useState({
    ocupacao: null,
    comandasAbertas: null,
    tempoMedio: null,
  });
  const [comandasSolicitadas, setComandasSolicitadas] = useState([]);
  const [showContasModal, setShowContasModal] = useState(false);
  const [imprimindo, setImprimindo] = useState(null);
  const [chamadasGarcon, setChamadasGarcon] = useState([]);
  const [showGarconModal, setShowGarconModal] = useState(false);
  const [dispensando, setDispensando] = useState(null);

  const Headers = {
    Authorization: `Bearer ${token}`,
    "x-tenant-slug": tenant.slug,
  };

  const toggleMenu = () => setMenuOpen((v) => !v);


  useEffect(() => {
    async function loadSubscription() {
      try {
        //const activeRestaurant = JSON.parse(localStorage.getItem("activeRestaurant"));

        if (!activeRestaurant) return; // fallback seguro

        const res = await api.get("/auth/assinatura/status", {
          headers: {
            "x-restaurant-id": activeRestaurant.id,
          },
        });

        setSubscription(res.data);
        setSubscriptionStatus(res.data?.status);
      } catch (err) {
        console.error("Erro ao carregar assinatura:", err);
      }
    }

    loadSubscription();
  }, []);

  // ======================================================
  // VERIFICAÇÃO DE LOGIN (NOVA LÓGICA)
  // ======================================================
  useEffect(() => {
    const hasAccess = localStorage.getItem("accessToken");
    //const hasLegacy = localStorage.getItem("token");
    const hasRefresh = localStorage.getItem("refreshToken");

    if (!hasAccess && !hasRefresh) {
      navigate("/login");
      return;
    }
  }, []);

  // ======================================================
  // CARREGAR RESTAURANTES REAIS DO BACKEND
  // ======================================================
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) return;

    if (storedRestaurants.length > 0) {
      setRestaurants(storedRestaurants);

      if (!activeRestaurant) {
        const first = storedRestaurants[0];
        localStorage.setItem("activeRestaurant", JSON.stringify(first));
        setActiveRestaurant(first);
      }
      return;
    }

    const loadRestaurants = async () => {
      try {
        const res = await api.get("/restaurants");

        const list = res.data || [];
        setRestaurants(list);
        localStorage.setItem("restaurants", JSON.stringify(list));

        if (!activeRestaurant && list.length > 0) {
          const first = list[0];
          localStorage.setItem("activeRestaurant", JSON.stringify(first));
          //setActiveRestaurant(first);
        }
      } catch (err) {
        console.error("Erro ao carregar restaurantes:", err);
      }
    };

    loadRestaurants();
  }, []);

  useEffect(() => {
    //if (!activeRestaurant) return;
    if (!localStorage.getItem("accessToken")) return;

    const loadMetrics = async () => {
      try {
        // === MESAS ===
        const mesasRes = await api.get(
          `/tables?restaurant_id=${activeRestaurant.id}`,
          { headers: Headers }
        );
        let mesas = mesasRes.data || [];

        mesas = mesas.filter(
          (m) => !m.name.toLowerCase().startsWith("delivery")
        );

        const ocupadas = mesas.filter((m) => m.status === "occupied").length;

        setOcupadas(ocupadas);
        const total = mesas.length;
        const ocupacao = total > 0 ? Math.round((ocupadas / total) * 100) : 0;

        // === COMANDAS ===
        const comandasRes = await api.get(
          `/comandas/restaurant/${activeRestaurant.id}`,
          { headers: Headers }
        );
        const todasComandas = comandasRes.data || [];

        const inicioDoDia = new Date();
        inicioDoDia.setHours(0, 0, 0, 0);

        let comandas = todasComandas.filter(
          (c) =>
            c.mesa &&
            !c.mesa.trim().toLowerCase().startsWith("delivery") &&
            new Date(c.createdAt) >= inicioDoDia
        );

        // Contas solicitadas — usa todas as comandas sem filtro de data/delivery
        const solicitadas = todasComandas.filter((c) => c.status === "solicitada");
        setComandasSolicitadas(solicitadas);

        // Chamadas de garçom
        const garconRes = await api.get(
          `/garcon/chamadas/${activeRestaurant.id}`,
          { headers: Headers }
        );
        setChamadasGarcon(garconRes.data || []);

        const umaHoraAtras = Date.now() - 60 * 60 * 1000;
        let pedidosUltimaHora = [];

        // Pedidos já vêm incluídos na resposta das comandas (elimina N+1 queries)
        let tempos = [];

        for (const c of comandas) {
          const pedidos = c.pedidos || [];

          pedidos.forEach((p) => {
            const criado = new Date(p.createdAt);
            const atualizado = new Date(p.updatedAt);

            if (criado >= umaHoraAtras) {
              pedidosUltimaHora.push(p);
            }

            let tempoMin = 0;

            if (p.status === "aberto") {
              tempoMin = (Date.now() - criado) / 60000;
            } else {
              tempoMin = (atualizado - criado) / 60000;
            }

            tempos.push(tempoMin);
          });
        }

        let tempoMedio = null;

        if (tempos.length > 0) {
          tempoMedio = Math.round(
            tempos.reduce((a, b) => a + b, 0) / tempos.length
          );
        }

        // ==========================
        // FLUXO DE COMANDAS EM 6 INTERVALOS
        // ==========================
        let intervalos = [0, 0, 0, 0, 0, 0];

        pedidosUltimaHora.forEach((p) => {
          const diffMin = Math.floor(
            (Date.now() - new Date(p.createdAt).getTime()) / 60000
          );
          const idx = Math.floor(diffMin / 10); // cada 10 minutos
          if (idx >= 0 && idx < 6) intervalos[5 - idx] += 1;
        });

        setFluxoComandas(intervalos); // EX: [0, 1, 2, 0, 3, 1]

        // ==========================
        // OCUPAÇÃO POR HORÁRIO (REAL + MOCK)
        // ==========================
        //const mesasRes = await api.get(`/tables?restaurant_id=${activeRestaurant.id}`);
        //const mesas = mesasRes.data || [];
        //const total = mesas.length;
        //const ocupadas = mesas.filter((m) => m.status === "occupied").length;

        const ocupacaoAtual =
          total > 0 ? Math.round((ocupadas / total) * 100) : 0;

        // MOCK suave baseado na ocupação atual
        const mock = [
          ocupacaoAtual * 0.4,
          ocupacaoAtual * 0.6,
          ocupacaoAtual * 0.8,
          ocupacaoAtual * 1.0,
          ocupacaoAtual * 0.7,
        ];

        setOcupacaoHorario(mock);

        setKpis({
          ocupacao,
          comandasAbertas: comandas.length,
          tempoMedio,
        });
      } catch (err) {
        console.error("Erro ao carregar métricas:", err);
      }
    };

    loadMetrics();

    const interval = setInterval(loadMetrics, 30000);
    return () => clearInterval(interval);
  }, [activeRestaurant, setKpis, setOcupadas]);

  const handleChangeRestaurant = (e) => {
    const id = e.target.value;

    const selected = restaurants.find((r) => r.id === id);
    if (!selected) return;

    setActiveRestaurant(selected);
    localStorage.setItem("activeRestaurant", JSON.stringify(selected));
  };

  const handleImprimir = async (comanda) => {
    setImprimindo(comanda.comanda_id);
    try {
      const pedidos = comanda.pedidos || [];
      const total = pedidos.reduce((acc, p) => acc + p.quantidade * Number(p.Menu?.preco || 0), 0);
      const agora = new Date().toLocaleString("pt-BR");

      let pixPayload = "";
      const cnpj = activeRestaurant?.cnpj;
      if (cnpj) {
        const txid = 'RST' + String(comanda.comanda_id).replace(/[^a-zA-Z0-9]/g, '').slice(-8);
        pixPayload = gerarPayloadPix({
          chave: cnpj,
          nome: activeRestaurant.nome || 'Restaurante',
          cidade: activeRestaurant?.address?.city || 'Brasil',
          valor: total,
          txid,
        });
      }

      const pixHtml = pixPayload ? `
        <hr/>
        <p style="text-align:center;margin:4px 0">Pague com Pix</p>
        <div id="qrpix" style="display:flex;justify-content:center;margin:6px 0"></div>
        <p style="text-align:center;font-size:10px">Abra seu banco · Pix · Ler QR Code</p>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
        <script>new QRCode(document.getElementById('qrpix'),{text:'${pixPayload}',width:120,height:120,correctLevel:QRCode.CorrectLevel.M});<\/script>
      ` : "";

      const linhas = pedidos.map(p => {
        const nome = p.Menu?.nome || "Item";
        const preco = Number(p.Menu?.preco || 0);
        const subtotal = preco * p.quantidade;
        return `<tr>
          <td>${p.quantidade}x ${nome}</td>
          <td style="text-align:right;white-space:nowrap;padding-left:8px">R$ ${subtotal.toFixed(2)}</td>
        </tr>`;
      }).join("");

      const html = `
        <html><head><title>Comanda</title>
        <style>
          * { box-sizing: border-box; }
          body { font-family: monospace; font-size: 12px; margin: 0; padding: 8px; }
          h2, p { text-align: center; margin: 3px 0; }
          hr { border: none; border-top: 1px dashed #000; margin: 4px 0; }
          table { width: 100%; border-collapse: collapse; }
          td { padding: 2px 0; word-break: break-word; }
          td:last-child { text-align: right; white-space: nowrap; padding-left: 8px; }
          .total { font-size: 14px; font-weight: bold; text-align: right; margin-top: 6px; }
          @media print { body { margin: 0; padding: 4px; } @page { margin: 4mm; } }
        </style></head>
        <body>
          <h2>${activeRestaurant.nome || "Restaurante"}</h2>
          <p>${agora}</p>
          <hr/>
          <p><strong>${comanda.mesa}</strong> — Comanda #${String(comanda.comanda_id).slice(-5)}</p>
          <hr/>
          <table>${linhas}</table>
          <hr/>
          <p class="total">Total: R$ ${total.toFixed(2)}</p>
          ${pixHtml}
          <br/><br/>
        </body></html>`;

      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:none;";
      document.body.appendChild(iframe);
      iframe.contentDocument.open();
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }, 800);
    } catch (err) {
      console.error("Erro ao imprimir:", err);
    } finally {
      setImprimindo(null);
    }
  };

  const handleDispensarGarcon = async (chamada) => {
    setDispensando(chamada.id);
    try {
      await api.patch(`/garcon/dispensar/${chamada.id}`, {}, { headers: Headers });
      setChamadasGarcon((prev) => prev.filter((c) => c.id !== chamada.id));
    } catch (err) {
      console.error("Erro ao dispensar garçom:", err);
      alert("Erro ao marcar como atendido.");
    } finally {
      setDispensando(null);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tenant");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("restaurants");
    localStorage.removeItem("activeRestaurant");
    localStorage.removeItem("token");
    clearSubscriptionStatus();
    localStorage.clear();

    navigate("/login");
  };

  return (
    <div className="home-root">
      {/* ======================================================
          HEADER
      ====================================================== */}
      <header className="home-navbar">
        <div className="home-navbar-left">
          <div className="logo-and-badge">
            <div className="home-logo" onClick={() => navigate("/home")}>
              <img
                src="/assets/logo-mesaclick.png"
                alt="MesaClick Logo"
                className="left-logo"
              />
            </div>

            {subscription && (
              <div className="subscription-badge">
                {subscription.status === "trial" && (
                  <span className="trial">
                    🔥 Teste grátis – {subscription.trial_days_left} dias
                    restantes
                  </span>
                )}

                {subscription.status === "active" && (
                  <span className="active">
                    ✔ Assinatura ativa – Expira em:{" "}
                    {subscription.plan_next_billing
                      ? new Date(
                        subscription.plan_next_billing
                      ).toLocaleDateString("pt-BR")
                      : "indefinido"}
                  </span>
                )}

                {subscription.status === "expired" && (
                  <span
                    className="expired"
                    onClick={() => navigate("/assinatura/upgrade")}
                  >
                    ❌ Assinatura expirada – Renovar agora
                  </span>
                )}
              </div>
            )}
          </div>

          <nav className="home-nav-links">
            <button className="home-nav-link home-nav-link-active">
              Dashboard
            </button>
            <button
              className="home-nav-link"
              onClick={() => navigate("/salao")}
            >
              Salão
            </button>
            <button
              className="home-nav-link"
              onClick={() => navigate("/menus")}
            >
              Menus
            </button>
            <button
              className="home-nav-link"
              onClick={() => navigate("/users")}
            >
              Usuários
            </button>
            <button
              className="home-nav-link"
              onClick={() => navigate("/relatorios")}
            >
              Relatórios
            </button>
            <button
              className="home-nav-link"
              onClick={() => navigate("/cozinha")}
            >
              Cozinha
            </button>

            <button
              className="home-nav-link"
              onClick={() => navigate("/delivery")}
            >
              Delivery
            </button>

            {subscription?.status === "trial" && (
              <button
                className="btn-upgrade-home"
                onClick={() => navigate("/assinatura/upgrade")}
              >
                Ativar Assinatura
              </button>
            )}
          </nav>
        </div>

        {/* Chamadas de Garçom */}
        <button
          className="contas-solicitadas-btn"
          onClick={() => setShowGarconModal(true)}
          title="Chamadas de garçom"
          style={{ marginRight: 8 }}
        >
          🛎️
          {chamadasGarcon.length > 0 && (
            <span className="contas-badge">{chamadasGarcon.length}</span>
          )}
        </button>

        {/* Contas Solicitadas */}
        <button
          className="contas-solicitadas-btn"
          onClick={() => setShowContasModal(true)}
          title="Contas solicitadas"
        >
          🧾
          {comandasSolicitadas.length > 0 && (
            <span className="contas-badge">{comandasSolicitadas.length}</span>
          )}
        </button>

        {/* Perfil */}
        <div className="relative">
          <button
            type="button"
            onClick={toggleMenu}
            className="flex items-center gap-3 rounded-full border border-theme bg-theme-soft px-4 py-2 text-sm font-semibold text-theme-main shadow-lg transition hover:border-cyan-400/40 hover:bg-white/10"
          >
            <img
              src="/assets/user.png"
              alt="Perfil"
              className="h-9 w-9 rounded-full border border-white/20 object-cover"
            />

            <div className="text-left home-profile-text">
              <p className="text-xs text-theme-muted">Bem-vindo</p>
              <p className="text-sm font-semibold text-theme-main">
                {user?.name || "Operador MesaClick"}
              </p>
            </div>
          </button>

          {menuOpen && (
            <div className="absolute right-0 mt-3 w-56 rounded-2xl border border-theme bg-floating-card p-4">
              <p className="text-sm font-semibold text-theme-main"> {user?.name || "Usuário"} </p>
              <p className="text-xs text-theme-muted">{user?.email}</p>
              <p className="text-xs text-theme-muted">
                Função:{" "}
                {{
                  owner: "Gerente",
                  staff: "Atendente",
                }[user?.role] || user?.role}
              </p>

              {/* seletor de restaurante ativo */}
              {restaurants.length > 0 && (
                <div className="mt-4">
                  <p className="text-xs text-slate-400 mb-1">Unidade ativa</p>

                  <select
                    value={activeRestaurant?.id || ""}
                    onChange={handleChangeRestaurant}
                    className="w-full rounded-xl px-3 py-2 text-sm home-restaurant-select focus:border-cyan-400/40"
                  >
                    {restaurants.map((rest) => (
                      <option key={rest.id} value={rest.id}>
                        {rest.nome}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="mt-4">
                <p className="text-xs text-slate-400 mb-2">Tema</p>

                <div className="flex gap-2">
                  <button
                    onClick={() => setTheme("dark")}
                    className={`flex-1 rounded-lg px-3 py-2 text-xs font-semibold ${theme === "dark"
                      ? "bg-green-600 text-white"
                      : "bg-btn-inactive text-btn-inactive border-btn"
                      }`}
                  >
                    🌙 Dark
                  </button>

                  <button
                    onClick={() => setTheme("light")}
                    className={`flex-1 rounded-lg px-3 py-2 text-xs font-semibold ${theme === "light"
                      ? "bg-green-600 text-white"
                      : "bg-btn-inactive text-btn-inactive border-btn"
                      }`}
                  >
                    ☀️ Light
                  </button>
                </div>
              </div>


              <button
                onClick={handleLogout}
                className="mt-4 w-full rounded-xl px-3 py-2 text-sm font-semibold transition btn-danger"
              >
                Sair
              </button>
            </div>
          )}
        </div>
      </header>

      {/* ======================================================
          HERO PRINCIPAL
      ====================================================== */}
      <main className="home-container">
        <section className="home-hero">
          <div className="home-hero-header">
            <div>
              <h1 className="home-hero-title">
                {activeRestaurant?.nome || "Selecione um restaurante"}{" "}
                {activeRestaurant && (
                  <span
                    className={`home-hero-badge ${activeRestaurant?.ativo ? "badge-green" : "badge-red"
                      }`}
                  >
                    {activeRestaurant?.ativo ? "Ativo" : "Inativo"}
                  </span>
                )}
              </h1>

              <p className="home-hero-subtitle">
                {activeRestaurant
                  ? "Visão geral do restaurante selecionado."
                  : "Nenhum restaurante ativo."}
              </p>
            </div>

            <button className="home-hero-cta" onClick={toggleMenu}>
              Trocar restaurante
            </button>
          </div>

          {/* MÉTRICAS */}
          <div className="home-hero-metrics">
            <div className="home-metric-card">
              <div className="metric-value">{kpis.ocupacao ?? "--"}%</div>
              <div className="metric-label">Ocupação</div>
              <div className="metric-sub">em tempo real</div>
            </div>

            <div className="home-metric-card">
              <div className="metric-value">{kpis.comandasAbertas ?? "--"}</div>
              <div className="metric-label">Comandas abertas</div>
              <div className="metric-sub">em atendimento</div>
            </div>

            <div className="home-metric-card">
              <div className="metric-value">
                {kpis.tempoMedio !== null ? `${kpis.tempoMedio} min` : "-- min"}
              </div>
              <div className="metric-label">Tempo médio</div>
              <div className="metric-sub">última hora</div>
            </div>
          </div>

          {/* micro gráficos */}
          <div className="home-hero-charts">
            <div className="home-chart-card">
              <div className="home-chart-header">
                Fluxo de Comandas (última hora)
              </div>

              <div className="home-chart-body home-chart-body-line">
                <div className="chart-dot-row">
                  {fluxoComandas.map((qtd, i) => (
                    <span
                      key={i}
                      className="dot"
                      style={{
                        width: `${6 + qtd * 4}px`,
                        height: `${6 + qtd * 4}px`,
                        backgroundColor: qtd > 0 ? "#3cff92" : "#2a2a2a",
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* legenda */}
              <div className="chart-x-axis">
                <span>0–10</span>
                <span>10–20</span>
                <span>20–30</span>
                <span>30–40</span>
                <span>40–50</span>
              </div>
            </div>

            <div className="home-chart-card">
              <div className="home-chart-header">Ocupação por horário</div>

              <div className="home-chart-body home-chart-body-bars">
                {ocupacaoHorario.map((value, i) => (
                  <div
                    key={i}
                    className="chart-bar"
                    style={{ height: `${Math.min(value, 100)}%` }}
                  />
                ))}
              </div>

              {/* legenda */}
              <div className="chart-x-axis">
                <span>18h</span>
                <span>19h</span>
                <span>20h</span>
                <span>21h</span>
                <span>Agora</span>
              </div>
            </div>
          </div>
        </section>

        {/* ======================================================
            AÇÕES RÁPIDAS
        ====================================================== */}
        <section className="home-section">
          <div className="home-section-header">
            <h2>Ações rápidas</h2>
            <p>Atalhos para tarefas comuns.</p>
          </div>

          <div className="home-quick-actions">
            <button
              className="home-action-card"
              onClick={() => navigate("/restaurantes")}
            >
              <span className="home-action-icon">➕</span>
              <div className="home-action-text">
                <span className="home-action-title">Novo restaurante</span>
                <span className="home-action-sub">Criar unidade</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/menus")}
            >
              <span className="home-action-icon">📄</span>
              <div className="home-action-text">
                <span className="home-action-title">Cardápios</span>
                <span className="home-action-sub">Gerenciar menus</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/salao")}
            >
              <span className="home-action-icon">🍽️</span>
              <div className="home-action-text">
                <span className="home-action-title">Salão</span>
                <span className="home-action-sub">Mesas e comandas</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/users")}
            >
              <span className="home-action-icon">👤</span>
              <div className="home-action-text">
                <span className="home-action-title">Usuários</span>
                <span className="home-action-sub">Equipes e permissões</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/relatorios")}
            >
              <span className="bi bi-clipboard2-data-fill home-action-icon"></span>
              <div className="home-action-text">
                <span className="home-action-title">Relatorios</span>
                <span className="home-action-sub">Estatisticas</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/cozinha")}
            >
              <span className="bi bi-fork-knife home-action-icon"></span>
              <div className="home-action-text">
                <span className="home-action-title">Cozinha</span>
                <span className="home-action-sub">Pedidos</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/delivery")}
            >
              <span className="bi bi-fork-knife home-action-icon"></span>
              <div className="home-action-text">
                <span className="home-action-title">Delivery</span>
                <span className="home-action-sub">Entregas</span>
              </div>
            </button>

            <button
              className="home-action-card"
              onClick={() => navigate("/configs")}
            >
              <span className="bi bi-gear-fill home-action-icon"></span>
              <div className="home-action-text">
                <span className="home-action-title">Configurações</span>
                <span className="home-action-sub">Impressoras e tablets</span>
              </div>
            </button>
          </div>
        </section>

        {/* ======================================================
            REDE DE RESTAURANTES
        ====================================================== */}
        <section className="home-section">
          <div className="home-section-header">
            <h2>Rede de restaurantes</h2>
            <p>Unidades conectadas ao MesaClick</p>
          </div>

          <div className="home-restaurants-grid">
            {restaurants.map((rest) => (
              <article className="home-restaurant-card" key={rest.id}>
                <div className="home-restaurant-header">
                  <div>
                    <h3>{rest.nome}</h3>

                    <span
                      className={`home-hero-badge ${rest?.ativo ? "badge-green" : "badge-red"
                        }`}
                    >
                      {rest?.ativo ? "Operando" : "Inativo"}
                    </span>
                  </div>

                  <button
                    className="home-restaurant-manage"
                    onClick={() => navigate("/salao")}
                  >
                    Gerenciar
                  </button>
                </div>

                <div className="home-restaurant-body">
                  <div className="home-restaurant-metric">
                    <span className="label">Mesas</span>
                    <span className="value">{rest.quantidade_mesas}</span>
                  </div>

                  <div className="home-restaurant-metric">
                    <span className="label">Ocupadas</span>
                    <span className="value"> {ocupadas ?? "--"} </span>
                  </div>

                  <div className="home-restaurant-metric">
                    <span className="label">Comandas</span>
                    <span className="value">
                      {" "}
                      {kpis.comandasAbertas ?? "--"}{" "}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>

      {/* ======================================================
          MODAL: CHAMADAS DE GARÇOM
      ====================================================== */}
      {showGarconModal && (
        <div className="contas-modal-overlay" onClick={() => setShowGarconModal(false)}>
          <div className="contas-modal" onClick={(e) => e.stopPropagation()}>
            <div className="contas-modal-header">
              <h2>🛎️ Chamadas de Garçom</h2>
              <button className="contas-modal-close" onClick={() => setShowGarconModal(false)}>✕</button>
            </div>

            {chamadasGarcon.length === 0 ? (
              <p className="contas-modal-empty">Nenhuma mesa chamando o garçom.</p>
            ) : (
              <div className="contas-modal-list">
                {chamadasGarcon.map((c) => (
                  <div key={c.id} className="contas-modal-item">
                    <div className="contas-modal-item-info">
                      <span className="contas-modal-mesa">Mesa {c.mesa}</span>
                      <span style={{ fontSize: 12, color: '#9ca3af' }}>
                        {new Date(c.createdAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                    <button
                      className="contas-modal-print-btn"
                      disabled={dispensando === c.id}
                      onClick={() => handleDispensarGarcon(c)}
                      style={{ background: '#16a34a' }}
                    >
                      {dispensando === c.id ? "..." : "✔ Atendido"}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ======================================================
          MODAL: CONTAS SOLICITADAS
      ====================================================== */}
      {showContasModal && (
        <div className="contas-modal-overlay" onClick={() => setShowContasModal(false)}>
          <div className="contas-modal" onClick={(e) => e.stopPropagation()}>
            <div className="contas-modal-header">
              <h2>🧾 Contas Solicitadas</h2>
              <button className="contas-modal-close" onClick={() => setShowContasModal(false)}>✕</button>
            </div>

            {comandasSolicitadas.length === 0 ? (
              <p className="contas-modal-empty">Nenhuma conta solicitada no momento.</p>
            ) : (
              <div className="contas-modal-list">
                {comandasSolicitadas.map((c) => (
                  <div key={c.comanda_id} className="contas-modal-item">
                    <div className="contas-modal-item-info">
                      <span className="contas-modal-mesa">{c.mesa}</span>
                      <span className="contas-modal-total">R$ {parseFloat(c.valor_total).toFixed(2)}</span>
                    </div>
                    <button
                      className="contas-modal-print-btn"
                      disabled={imprimindo === c.comanda_id}
                      onClick={() => handleImprimir(c)}
                    >
                      {imprimindo === c.comanda_id ? "Enviando..." : "🖨️ Imprimir"}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <footer className="home-footer">
        <span>
          © {new Date().getFullYear()} MesaClick • Faenetech Sistemas e Tecnologia - CNPJ:
          54.172.074/0001-34
        </span>
      </footer>
    </div>
  );
};

export default HomePage;
